import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Services } from './components/Services';
import { Method } from './components/Method';
import { Results } from './components/Results';
import { WhyUs } from './components/WhyUs';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen" data-id="element-0">
      <Nav data-id="element-1" />
      <Hero data-id="element-2" />
      <Marquee data-id="element-3" />
      <Services data-id="element-4" />
      <Method data-id="element-5" />
      <Results data-id="element-6" />
      <WhyUs data-id="element-7" />
      <Contact data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}